<template>
  <div >
      <my-form  readonly table>
      <el-form-item label="附件" class="table-full-row">
            <my-upload readonly v-if="form.title==='查看专家提问附件'" :file-guid="form.fileguid"></my-upload>
            <my-upload readonly v-if="form.title==='查看投标人回复附件'" :file-guid="form.exthffileguid"></my-upload>
     </el-form-item> 
       </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    props: {
        form: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
    },
    created() {  
       
    },
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__row .cell {
 line-height: 16px;
}
/deep/ .el-table__row .-el-table_1_column_1 .cell {
    width: 220px!important;
}
</style>